"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const utils_1 = require("utils");
const AnnouncementBanner_1 = __importDefault(require("../../components/AnnouncementBanner"));
const reducer_1 = require("../../reducer");
const StoreInformationContainer_1 = __importDefault(require("../components/StoreInformationContainer"));
const utils_2 = require("../views/DocUpload/utils");
function LocationManagement({ currentLocation, getProposedEnrollmentDataChanges, }) {
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const [isLoading1, setIsLoading1] = (0, react_1.useState)(false);
    const [isLoading2, setIsLoading2] = (0, react_1.useState)(false);
    const [changesList, setChangesList] = (0, react_1.useState)(null);
    const [canSubmit, setCanSubmit] = (0, react_1.useState)(null);
    const [needsFile, setNeedsFile] = (0, react_1.useState)(null);
    const [markedCompleteOrSkipped, setMarkedCompleteOrSkipped] = (0, react_1.useState)({});
    // Query
    const { data: enrollments } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1LocationsIdEnrollmentsQuery)({
        id: currentLocation.locationId,
        status: 'entered',
    });
    const getProposedChanges = async () => {
        setIsLoading1(true);
        const changesResp = await getProposedEnrollmentDataChanges(currentLocation.locationId);
        const changesMonitored = changesResp.filter((itm) => itm.status === 'created' || itm.status === 'pending_review');
        setChangesList([...changesMonitored]);
        if (changesResp && changesResp.length > 0) {
            const tmpChanges = changesResp[changesResp.length - 1];
            if (tmpChanges.status === 'pending_review') {
                setCanSubmit(false);
                setNeedsFile(false);
            }
            if (tmpChanges.files.length > 0 &&
                tmpChanges.status !== 'pending_review') {
                setCanSubmit(true);
            }
        }
        else {
            setCanSubmit(true);
        }
        setIsLoading1(false);
    };
    async function createProposedChangesMap(curData) {
        setIsLoading2(true);
        if (curData) {
            const proposedChangeMap = await (0, utils_2.setupChangesMap)(curData, getProposedEnrollmentDataChanges);
            const dataStruct = (0, utils_2.createDataStructure)(proposedChangeMap, curData);
            if (dataStruct && !!dataStruct.length) {
                const currentLocationProposedChanges = proposedChangeMap.get(currentLocation.adsStoreNumber);
                const needsFileUploadRes = (0, utils_2.needsFileUpload)(dataStruct[0].bankingChanged, dataStruct[0].entityChanged, currentLocationProposedChanges?.files);
                const needsFile = needsFileUploadRes?.needsBankingFileUpload ||
                    needsFileUploadRes?.needsEntityFileUpload;
                setNeedsFile(needsFile);
                setCanSubmit(!needsFile && dataStruct[0].anythingChanged);
            }
            else {
                setNeedsFile(false);
            }
        }
        setIsLoading2(false);
    }
    const gotoDocMgmt = () => {
        history.push({
            pathname: '/merchant' + config_1.PATH.DOCUMENT_MANAGEMENT,
        });
    };
    const refreshPage = () => {
        if (currentLocation) {
            createProposedChangesMap([currentLocation]);
        }
        getProposedChanges();
    };
    const hasEnrollments = (0, react_1.useMemo)(() => {
        return !!enrollments?.length;
    }, [enrollments]);
    (0, react_1.useEffect)(() => { }, [markedCompleteOrSkipped]);
    (0, react_1.useEffect)(() => {
        if (currentLocation) {
            createProposedChangesMap([currentLocation]);
            getProposedChanges();
            if (!currentLocation.metadata ||
                currentLocation?.needsToSignNewDealTerms) {
                return history.push(config_1.MERCHANT_PORTAL_URL);
            }
        }
    }, [currentLocation]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "new-deal-container rm-absolute z-100", children: (0, jsx_runtime_1.jsxs)("div", { className: "verify-store-information-title w100", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Location Management" }), isLoading1 || isLoading2 ? ((0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true })) : ((0, jsx_runtime_1.jsx)("div", { className: "verify-store-information", children: needsFile !== null && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [needsFile &&
                                        currentLocation.isCurrentLocationManagerSigner ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(AnnouncementBanner_1.default, { fullWidth: true, callback: gotoDocMgmt, btnText: `UPLOAD DOCUMENTS`, bodyText: `To validate your updates, Alphaeon Credit requires documentation proof. Please upload the necessary documents. ` }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {})] })) : null, (0, jsx_runtime_1.jsx)(StoreInformationContainer_1.default, { canSubmit: canSubmit, setMarkedCompleteOrSkipped: setMarkedCompleteOrSkipped, enrollmentData: currentLocation, index: 0, singleDisplay: true, keepHeader: false, allowEdit: currentLocation.isCurrentLocationManagerSigner, hasEnrollments: hasEnrollments, refreshPage: refreshPage, changesList: changesList })] }) }, `store-${currentLocation.locationId}`)) }))] }) }) }));
}
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
        currentLocationIndex: reducer_1.selectors.currentLocationIndex(state),
    };
}
const mapDispatchToProps = {};
const mapApiAuthToProps = {
    getProposedEnrollmentDataChanges: apiActions.getProposedEnrollmentDataChanges,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(LocationManagement);
